import backend from '@api/backend'
import { AlertGroup, AlertQuery, AlertStatus } from '../model/alert.model'
import { displayToast } from '@common/utils/appToast'
import { ActionTypes } from '../context/alert.reducer'
import { WaterUsageQueryMultipleDevices } from '@data/waterUsage/model/waterUsage.model'

export type AlertStatsQuery = {
  deviceId: string
  to: string
  from: string
  type?: string
}

export const loadAlertsAction = () => {
  return async (dispatch: any) => {
    dispatch({
      type: ActionTypes.LOADING,
    })
    try {
      const response = await backend.get('/usage_alerts', {
        params: {status: ['open', 'in_progress']},
        paramsSerializer: {
          indexes: null
        }
      })
      dispatch({
        type: ActionTypes.INIT,
        payload: { alerts: [...response.data.data], historicalAlerts: [] },
      })
    } catch (error) {
      dispatch({
        type: ActionTypes.ERROR,
        error,
      })
    }
  }
}

export const loadHistoricalAlertsAction = (query: AlertQuery | null = null) => {
  return async (dispatch: any) => {
    dispatch({
      type: ActionTypes.ALERT_UPDATING,
    })

    try {
      const historicalResponse = await backend.get('/usage_alerts/history', {
        params: query,
        paramsSerializer: {
          indexes: null
        }
      })
      dispatch({
        type: ActionTypes.HISTORICAL_ALERTS,
        payload: { historicalAlerts: historicalResponse.data },
      })
    } catch (error) {
      dispatch({
        type: ActionTypes.ERROR,
        error,
      })
    }
  }
}

export const loadHistoricalAlertsStatsDeviceAction = (query: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: ActionTypes.LOADING,
    })
    const payload: any = {}
    try {
      await Promise.all(
        Object.values(query).map(async (q: any) => {
          const response = await backend.get(
            `/usage_alerts/${q.deviceId}/stats`, {params: {query}}
          )
          payload[q.type] = response.data
        }),
      )
      dispatch({
        type: ActionTypes.SINGLE_DEVICE_STATS,
        payload: payload,
      })
    } catch (error) {
      dispatch({
        type: ActionTypes.ERROR,
        error,
      })
    }
  }
}

export const loadMultipleDevicesHistoricalAlertsStatsAction = (params: WaterUsageQueryMultipleDevices, period: string) => {
  return async (dispatch: any) => {
    dispatch({
      type: ActionTypes.LOADING,
    })

    try {
      // Create an array of promises for the requests

      const promises = await Promise.all(
        params.deviceIds.map(async (deviceId: string) => {
          const response = await backend.get(
            `/usage_alerts/${deviceId}/stats`, {
              params: {
                startDate: params.startDate,
                endDate: params.endDate,
                idType: params.idType
              }
            })
          return { [period]: response.data }
        })
      )

      // Wait for all promises to resolve
      const allResponses = await Promise.all(promises)
      dispatch({
        type: ActionTypes.MULTIPLE_DEVICES_STATS,
        payload: allResponses,
      })
    } catch (error) {
      dispatch({
        type: ActionTypes.ERROR,
        error,
      })
    }
  }
}

export const ackAlertsAction = (
  alertGroup: AlertGroup,
  priorityTier: number,
  status: AlertStatus,
) => {
  return async (dispatch: any) => {
    dispatch({
      type: ActionTypes.ALERT_UPDATING,
    })
    try {
      const alerts = alertGroup.alerts.map((a) => {
        return {
          id: a.id,
          // ack_comment: comment,
          ack_result: priorityTier,
          status: status === AlertStatus.CLOSED ? 'closed' : 'in_progress',
          valid: a.valid,
          exclude_usage: a.excludeUsage,
        }
      })
      const alertsUpdate = {
        group_id: alertGroup.gid,
        // comment: comment,
        alerts: alerts,
      }
      await backend.patch(`/usage_alerts/${alertGroup.deviceId}`, alertsUpdate)
      alertGroup.status = status
      dispatch({
        type: ActionTypes.ACK_ALERT,
        payload: { alertGroup, priorityTier },
      })
      displayToast({
        type: 'success',
        message: 'Success',
      })
    } catch (error) {
      dispatch({
        type: ActionTypes.ERROR,
        error,
      })
      displayToast({
        type: 'error',
        message: 'Something went wrong, please try again',
      })
    }
  }
}
